import { useQuery } from "@tanstack/react-query";

import { getFieldListByFarmId } from "services";

import { GET_FIELDS } from "consts";

import { FieldListField } from "models";

export const useGetFieldsByFarmId = ({ farmId, enabled = true }: { farmId: string; enabled?: boolean }) =>
  useQuery<FieldListField[]>({
    queryKey: [GET_FIELDS, farmId],
    queryFn: () => getFieldListByFarmId({ farmId }),
    enabled: enabled && !!farmId,
  });
